import { Typography } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../../StockManagementState'
import FormSearchProducts from '../../../../components/FormSearchProducts/FormSearchProducts'
import FormResendUpdateFlv from '../../components/FormResendUpdateFlv/FormResendUpdateFlv'
import * as S from './FlvReleasePage.styles'

const FlvReleasePage = () => {
  const dispath = useDispatch()

  useEffect(() => {
    dispath(actions.clearProperty(['flvProductInfoForRelease', 'selectedFlvProducts']))
  }, [dispath])

  return (
    <S.Wrapper>
      <Typography variant='h5' fontWeight='bold'>Liberação FLV</Typography>
      <FormSearchProducts searchWithFC searchFlvProducts hasRequiredField={false} hasNoneOption/>
      <FormResendUpdateFlv />
    </S.Wrapper>
  )
}

export default FlvReleasePage
